"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MetricDataCell = _interopRequireDefault(require("./MetricDataCell"));

require("./style.css");

var _excluded = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledRow = function StyledRow(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("header", _extends({
    className: "metrics-group-item-row"
  }, rest), children);
};
/* eslint react/prefer-stateless-function:0 */


var MetricGroupItem = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MetricGroupItem, _React$Component);

  function MetricGroupItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MetricGroupItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        data = _this$props.data,
        filteredSpeakers = _this$props.filteredSpeakers; // Filter out 'CALLER' as this is synonymous with 'CUSTOMER'
    // Section order is strictly determined by speakers object in ./index.js

    var sections = filteredSpeakers.map(function (speaker) {
      return speaker.toLowerCase();
    });
    return /*#__PURE__*/_react["default"].createElement(StyledRow, null, /*#__PURE__*/_react["default"].createElement("div", null, (0, _lodash.get)(data, "label", "--")), sections.map(function (section) {
      var value = (0, _lodash.get)(data, "speaker." + section + ".val", undefined);

      if (Number.isNaN(value) || !(0, _lodash.isNumber)(value)) {
        value = "--";
      }

      var units = (0, _lodash.get)(data, "units", "empty");
      return /*#__PURE__*/_react["default"].createElement(_MetricDataCell["default"], {
        key: section,
        className: "data-cell",
        units: units,
        value: value
      });
    }));
  };

  return MetricGroupItem;
}(_react["default"].Component);

var _default = MetricGroupItem;
exports["default"] = _default;
MetricGroupItem.propTypes = process.env.NODE_ENV !== "production" ? {
  data: _propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    units: _propTypes["default"].string.isRequired,
    speaker: _propTypes["default"].shape({
      val: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
    }).isRequired
  }).isRequired
} : {};